import type { ExpressionReferenceFormFieldFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { RegionImage } from "../../regions/RegionImage";
import { FormField, FormLabel } from "@acdc2/ui/components/access-form";

type Props = {
  fragment: ExpressionReferenceFormFieldFragment;
};

export function ExpressionReferenceFormField({ fragment }: Props) {
  const { t } = useTranslation();

  return (
    <FormField name="expressionReference">
      <FormLabel>{t("ExpressionReferenceFormField.label")}</FormLabel>
      <div className="p-4 rounded-md border bg-white">
        <RegionImage fragment={fragment} />
      </div>
    </FormField>
  );
}
